import { render, staticRenderFns } from "./PetDetails.vue?vue&type=template&id=91eb81ca"
import script from "./PetDetails.vue?vue&type=script&lang=js"
export * from "./PetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports